module.exports = __webpack_public_path__ + "img/hyal-5.d05d1ac3.png";